import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const WORDMARK_PATH =
  "M411.984 297V219.133C411.984 192.238 396.359 180.456 379.454 180.456C362.292 180.456 345.899 194.543 345.899 223.231V297H321.054V159.708H343.338V184.042C350.254 168.417 365.366 156.891 387.138 156.891C408.398 156.891 422.23 167.136 429.914 182.761C438.367 168.161 454.503 156.891 476.788 156.891C507.269 156.891 527.504 178.663 527.504 214.01V297H502.658V219.133C502.658 195.056 490.107 180.456 470.384 180.456C453.223 180.456 436.83 191.982 436.83 219.133V297H411.984ZM611.628 299.818C577.818 299.818 554.765 273.691 554.765 237.575V159.708H579.354V236.038C579.354 259.603 594.723 276.253 617.007 276.253C640.572 276.253 655.941 260.116 656.965 227.586V159.708H681.811V297H659.527V272.41C649.281 289.06 632.12 299.818 611.628 299.818ZM815.487 297V220.926C815.487 197.361 800.119 180.456 777.834 180.456C754.269 180.456 738.901 196.592 737.876 229.122V297H713.03V159.708H735.315V184.554C745.56 167.648 762.722 156.891 783.213 156.891C817.024 156.891 840.077 183.017 840.077 219.389V297H815.487ZM931.745 299.818C891.275 299.818 860.282 268.824 860.282 228.61C860.282 187.884 891.019 156.891 931.745 156.891C961.202 156.891 988.353 172.259 995.525 206.07L971.191 210.168C966.837 188.652 948.395 180.456 931.745 180.456C905.363 180.456 885.128 201.459 885.128 228.61C885.128 255.505 905.363 276.253 931.745 276.253C949.675 276.253 967.605 268.056 972.728 246.796L997.318 249.102C990.146 284.961 959.409 299.818 931.745 299.818ZM1119.92 297V220.926C1119.92 197.361 1104.29 180.456 1082.01 180.456C1058.44 180.456 1043.33 196.592 1042.3 229.122V297H1017.46V106.943H1042.3V183.017C1052.04 166.112 1068.17 156.891 1087.64 156.891C1122.48 156.891 1144.51 181.48 1144.51 218.621V297H1119.92ZM1173.68 297V159.708H1198.52V297H1173.68ZM1172.39 133.325V104.894H1199.8V133.325H1172.39Z";

const munchiLogoVariants = cva("shrink-0", {
  variants: {
    tone: {
      brand: "text-[#330E1F] dark:text-white",
      inherit: "",
    },
  },
  defaultVariants: { tone: "brand" },
});

interface MunchiLogoProps extends VariantProps<typeof munchiLogoVariants> {
  variant?: "mark" | "wordmark";
  className?: string;
}

export function MunchiLogo({
  variant = "wordmark",
  tone,
  className,
}: MunchiLogoProps) {
  return (
    <svg
      viewBox={variant === "mark" ? "0 93 258 236" : "0 93 1200 236"}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Munchi"
      className={cn(munchiLogoVariants({ tone }), className)}
      data-testid={`layout.munchiLogo.${variant}`}
    >
      <ellipse cx="41.9053" cy="222.441" rx="41.9053" ry="105.601" />
      <ellipse
        cx="128.653"
        cy="222.343"
        rx="40.9805"
        ry="96.8905"
        transform="rotate(15.3086 128.653 222.343)"
      />
      <ellipse cx="216.237" cy="210.706" rx="41.9053" ry="117.335" />
      {variant === "wordmark" && <path d={WORDMARK_PATH} />}
    </svg>
  );
}
